<template>
  <v-card v-if="designgroup">
    <v-card-title>
      {{ designgroup.nameHierarchy }}
    </v-card-title>
    <v-card-subtitle class="caption">
      <v-row>
        <v-col cols="auto"> <span class="font-weight-bold">Id</span> {{ designgroup.id }} </v-col>
        <v-col
          v-if="designgroup.industry"
          cols="auto"
        >
          <span class="font-weight-bold">Industry</span>
          {{ designgroup.industry.name }}
        </v-col>
        <v-col
          v-if="designgroup.topic"
          cols="auto"
        >
          <span class="font-weight-bold">Topic</span>
          {{ designgroup.topic.name }}
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-divider />
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="designgroup.name"
              label="Name"
              outlined
              hide-details="auto"
            />
          </v-col>
          <v-col
            v-if="designgroup.popularity"
            cols="12"
          >
            <v-select
              v-model="designgroup.popularity.id"
              label="Popularity"
              :items="popularity"
              :rules="[$rules.required]"
              outlined
              hide-details="auto"
              item-value="id"
              item-text="name"
            />
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="designgroup.active"
              label="Active?"
              color="primary"
              inset
              hide-details
              outlined
            />
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="designgroup.isAdminGroup"
              label="Is admin group?"
              color="primary"
              inset
              hide-details
              outlined
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-text>
      <v-btn
        color="primary"
        :loading="saving"
        block
        @click="save"
      >
        Save
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'EditDesignGroup',

  components: {},

  data() {
    return {
      loading: false,
      valid: false,
      saving: false
    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },
    designgroup: {
      get() {
        return this.$store.getters['designgroups/edit_designgroup'];
      },
      set(val) {
        this.$store.dispatch('designgroups/edit', val);
      }
    },
    ...mapGetters({
      units: 'lookup/units',
      folds: 'lookup/folds',
      popularity: 'lookup/popularity'
    })
  },

  async mounted() {},

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('designgroups/update', this.designgroup)
        .then(() => {
          this.$root.$snackbarSuccess('Design group saved');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
